/** @flow */

import React from "react";
import classNames from "classnames";
import "./icons.style.scss";

type Props = $Exact<{
  color?: string,
  className?: string,
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void,
}>;

const PageArrowIcon = (props: Props) => (
  <svg
    className={classNames("icons", props.color, props.className, {
      charcoal: !props.color,
    })}
    viewBox="-1 -1 20 18"
    onClick={props.onClick}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fill="none" strokeLinecap="round" strokeLinejoin="round">
      <path d="M0.5,8 L17.5,8" />
      <polyline points="8 0 0 8 8 16" />
    </g>
  </svg>
);

export default PageArrowIcon;
